// extracted by mini-css-extract-plugin
export default {"Loader-backdrop":"Loader_Loader-backdrop__uiqNa","Loader-container":"Loader_Loader-container__KB0WJ","Loader":"Loader_Loader__wqo9C","l3":"Loader_l3__tKHgb"};